import { render, staticRenderFns } from "./PageClients.vue?vue&type=template&id=2064cd24&scoped=true"
import script from "./PageClients.vue?vue&type=script&lang=js"
export * from "./PageClients.vue?vue&type=script&lang=js"
import style0 from "./PageClients.vue?vue&type=style&index=0&id=2064cd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064cd24",
  null
  
)

export default component.exports